import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CONSTANTS } from 'src/app/core/constants/constants';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
})
export class SearchFormComponent implements OnInit, OnDestroy {
  @Input() placeholder = '';
  @Input() paramName = 'name';
  @Input() debounce = true;
  @Input() debounceTime = CONSTANTS.LOCAL_SAVE_DEBOUNCE;
  @Output() search = new EventEmitter<{ [key: string]: string }>();

  form: UntypedFormGroup;
  subscription: Subscription;

  constructor() {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  buildForm(): void {
    this.form = new UntypedFormGroup({
      query: new UntypedFormControl(''),
    });
    this.watchFormChanges();
  }

  watchFormChanges(): void {
    this.subscription = this.form.valueChanges
      .pipe(debounceTime(this.debounce ? this.debounceTime : 0))
      .subscribe((_) => {
        const output = {};
        output[this.paramName] = String(this.form.value.query);
        this.search.emit(output);
      });
  }
}
